module.exports = __webpack_public_path__ + "static/media/icon_ownit.47125560.svg";